import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiInsightIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 18,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 18,
			fill: "url(#paint0_linear_9636_570351)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75933 10.4766C12.0346 7.87697 15.7184 7.327 18.5855 8.84668C19.2569 9.20263 19.2994 10.0972 18.7623 10.6348C18.3143 11.0827 17.6114 11.1183 17.0269 10.874C15.2182 10.1183 13.0298 10.5368 11.6412 12.123C10.2112 13.7573 10.0745 16.1587 11.313 17.9424L12.981 20.3438V22.1885L12.9908 22.2891C13.0377 22.517 13.2401 22.6891 13.482 22.6885L16.8648 22.6797C17.1058 22.679 17.3075 22.5076 17.3541 22.2803L17.3638 22.1797V20.333L18.1832 19.1836C18.6178 18.5739 19.4875 18.4808 20.0416 18.9844C20.5098 19.4102 20.5865 20.1193 20.2193 20.6348L19.8638 21.1328V22.1797C19.8636 23.2996 19.2483 24.2748 18.3384 24.79C18.5034 24.9683 18.6049 25.2067 18.605 25.4688C18.6048 26.0208 18.1571 26.4687 17.605 26.4688H17.2378C17.3314 26.6208 17.3871 26.7996 17.3873 26.9912C17.3871 27.5433 16.9393 27.9911 16.3873 27.9912H14.0513C13.4991 27.9912 13.0515 27.5434 13.0513 26.9912C13.0515 26.7997 13.1063 26.6207 13.1998 26.4688H12.8316C12.2798 26.4684 11.8318 26.0206 11.8316 25.4688C11.8317 25.2268 11.9179 25.004 12.0611 24.8311C11.1208 24.3248 10.4813 23.3315 10.481 22.1885V21.127L9.25933 19.3682C7.36514 16.6403 7.57547 12.9723 9.75933 10.4766ZM24.2945 20.0488C24.4704 19.599 25.1079 19.5989 25.2837 20.0488C25.7152 21.1539 26.5889 22.0284 27.6939 22.46C28.1442 22.6358 28.1442 23.2734 27.6939 23.4492C26.5889 23.8808 25.7152 24.7553 25.2837 25.8604C25.1079 26.3103 24.4704 26.3102 24.2945 25.8604C23.863 24.7551 22.9886 23.8807 21.8834 23.4492C21.4333 23.2734 21.4333 22.6358 21.8834 22.46C22.9886 22.0285 23.863 21.154 24.2945 20.0488ZM22.2027 9.38867C22.4771 8.68695 23.4704 8.68686 23.7447 9.38867C24.4177 11.1125 25.7815 12.4764 27.5054 13.1494C28.2074 13.4237 28.2072 14.417 27.5054 14.6914C25.7816 15.3644 24.4177 16.7284 23.7447 18.4521C23.4705 19.1545 22.4769 19.1545 22.2027 18.4521C21.5297 16.7283 20.1658 15.3644 18.4419 14.6914C17.7397 14.4172 17.7396 13.4236 18.4419 13.1494C20.1657 12.4764 21.5297 11.1125 22.2027 9.38867Z",
			fill: "url(#paint1_linear_9636_570351)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_9636_570351",
			x1: 0,
			y1: 0,
			x2: 37.75,
			y2: 1.93951,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .485,
				stopColor: "#DCEBFE",
				stopOpacity: .5
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F7D8FF",
				stopOpacity: .5
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_9636_570351",
			x1: 7.96831,
			y1: 8.00879,
			x2: 29.0065,
			y2: 9.09407,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .485,
				stopColor: "#146EF5"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#C467DE"
			})]
		})] })
	]
});
export default SvgAiInsightIcon;
